var lib_core = require("lib-core");

var PosAngleFlipData = require("../abstract/posAngleFlipData.js");
var SymbolTerminalData = require("./../symbol/symbolTerminalData.js");
var SymbolTerminalInstance = require("./symbolTerminalInstance.js");

var SymbolInstanceData = function (symbolDescription, pos, angle, flip, name) {
    var self = this;

    this.registerInstanceClass(["terminals"], SymbolTerminalData, SymbolTerminalInstance);
    lib_core.InstanceBuilder.call(this, symbolDescription);
    this.addPosAngleFlip(pos, angle, flip);

    this.name = this.value("name", true);

    this.terminalMap = this.map("terminalMap", false);

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            return self.description().boundingBox().flip(self.xflip()).rotate(self.angle()).translate(self.pos());
        },
        [[this, this.onBubble]]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(){
            return self.boundingBox().getPoly();
        },
        [[this, this.onBubble]]
    );

    //tricky shit: observers changing the datamodel
    this.terminalMap.forEach(function(terminal) {
        terminal.onDie('terminal_map_die', function() {
            self.terminalMap.remove(terminal);
        });
    });
    this.terminalMap.onPut({}, function(terminal) {
        terminal.onDie('terminal_map_die', function() {
            self.terminalMap.remove(terminal);
        });
    });
    this.terminalMap.onRemove({}, function(terminal) {
        terminal.removeHandlers('terminal_map_die');
    });

    if (name != undefined) this.name(name);
};
lib_core.inherit(SymbolInstanceData, lib_core.InstanceBuilder);
lib_core.mixin(SymbolInstanceData, PosAngleFlipData);

lib_core.JsonParser.registerClass(SymbolInstanceData, "SymbolInstanceData");

module.exports = SymbolInstanceData;

SymbolInstanceData.prototype.getTitle = function () {
    return this.description().metaData().name();
};

//copy as much info from the old instance as possible
SymbolInstanceData.prototype.transferDataFromInstance = function(oldInstance) {
    var self = this;
    this.pos(oldInstance.pos());
    this.angle(oldInstance.angle());
    this.xflip(oldInstance.xflip());

    oldInstance.terminalMap.forEach(function(oldSymbolTerminal, logicTerminal) {
        var symbolTerminal = null;
        self.terminals.forEach(function(i, aSymbolTerminal) {
            if(aSymbolTerminal.template.versions_id === oldSymbolTerminal.template.versions_id)
                symbolTerminal = aSymbolTerminal;
        });
        if(symbolTerminal) {
            self.terminalMap.put(symbolTerminal, logicTerminal);
        }
    });
};
